import styled, { createGlobalStyle } from "styled-components";

const colors = {
  textSecondary: "#6B778C",
  success: "#28a745",
  danger: "#dc3545",
  link: "#2563eb",
  orange: "#F8981D",
};

export const GlobalPopupStyles = createGlobalStyle`
  .custom-form-popup .dx-popup-title {
    background-color: ${colors.orange} !important;
    padding: 16px 24px;
    border-bottom: none;

    .dx-toolbar-label {
      white-space: normal !important;
      line-height: 1.4 !important;
      height: auto !important;
      font-size: 18px !important;
      font-weight: 600 !important;
      color: #fff !important;
    }

    .dx-closebutton .dx-icon {
      color: #fff !important;
    }
  }
`;

const BaseButton = styled.button`
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
  &:focus {
    outline: none;
  }
`;

export const SaveButton = styled(BaseButton)`
  border: 2px solid ${colors.success};
  color: ${colors.success};
  &:hover {
    background-color: ${colors.success};
    color: #fff;
  }
`;

export const CancelButton = styled(BaseButton)`
  border: 2px solid ${colors.danger};
  color: ${colors.danger};
  margin-right: 12px;
  &:hover {
    background-color: ${colors.danger};
    color: #fff;
  }
`;

export const PopupFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #ddd;
  margin-top: 1rem;
`;

export const FormContainer = styled.div`
  padding: 1rem;
`;

export const NameLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${colors.link};
  font-weight: 600;
  cursor: pointer;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
`;

export const Hint = styled.p`
  margin: 8px 0 0;
  font-size: 13px;
  color: ${colors.textSecondary};
`;

export const EstatusBadge = styled.span<{ $active?: boolean }>`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  background-color: ${({ $active }) => ($active ? "#16a34a" : "#71717a")};
  text-align: center;
  min-width: 72px;
`;
